export var environment = {
  firebaseConfig: {
    apiKey: "AIzaSyA8tZphgoC6Ur-ayP5WeFqwVZfnMnbUaCA",
    authDomain: "harmonised-2fa4f.firebaseapp.com",
    databaseURL: "https://harmonised-2fa4f.firebaseio.com",
    projectId: "harmonised-2fa4f",
    storageBucket: "harmonised-2fa4f.appspot.com",
    messagingSenderId: "103658523574",
  },
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts